class ReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.counter = null;
    this.swiperElement = null;
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init() {
    this.counter = this.querySelector('.reviews-carousel__counter');
    this.swiperElement = this.querySelector('swiper-slider');
    
    if (this.swiperElement && this.counter) {
      // Initialiser le counter avec les valeurs par défaut
      this.initializeCounter();
      
      // Attendre que Swiper soit complètement initialisé
      setTimeout(() => {
        this.setupSwiperEvents();
      }, 100);
      
      // Observer les changements dans le DOM pour détecter les changements de slides
      this.setupObserver();
    }
  }

  initializeCounter() {
    const slides = this.querySelectorAll('.swiper-slide');
    const totalSlides = slides.length;
    
    if (totalSlides > 0) {
      this.counter.textContent = `1 / ${totalSlides}`;
    }
  }

  setupSwiperEvents() {
    // Essayer d'accéder à l'instance Swiper directement
    if (this.swiperElement.swiper) {
      this.swiper = this.swiperElement.swiper;
      this.bindSwiperEvents();
    } else {
      // Écouter les événements sur l'élément swiper-slider
      this.swiperElement.addEventListener('swiper:init', this.handleSwiperInit.bind(this));
      this.swiperElement.addEventListener('swiper:slidechange', this.updateCounter.bind(this));
      this.swiperElement.addEventListener('swiper:slidechangetransitionend', this.updateCounter.bind(this));
      
      // Fallback: vérifier périodiquement si Swiper est initialisé
      const checkSwiper = setInterval(() => {
        if (this.swiperElement.swiper) {
          this.swiper = this.swiperElement.swiper;
          this.bindSwiperEvents();
          clearInterval(checkSwiper);
        }
      }, 100);
      
      // Arrêter la vérification après 5 secondes
      setTimeout(() => clearInterval(checkSwiper), 5000);
    }
  }

  bindSwiperEvents() {
    if (this.swiper) {
      this.swiper.on('slideChange', () => {
        this.updateCounter();
      });
      
      this.swiper.on('slideChangeTransitionEnd', () => {
        this.updateCounter();
      });
      
      // Mettre à jour immédiatement
      this.updateCounter();
    }
  }

  setupObserver() {
    // Observer les changements de classe active sur les slides
    this.observer = new MutationObserver(() => {
      this.updateCounter();
    });
    
    const slides = this.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      this.observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  handleSwiperInit(event) {
    this.swiper = event.detail[0] || event.detail;
    this.bindSwiperEvents();
  }

  updateCounter() {
    if (!this.counter) return;
    
    let currentSlide = 1;
    let totalSlides = this.querySelectorAll('.swiper-slide').length;
    
    if (this.swiper) {
      // Utiliser realIndex pour les loops, sinon activeIndex
      currentSlide = (this.swiper.realIndex !== undefined ? this.swiper.realIndex : this.swiper.activeIndex) + 1;
      totalSlides = this.swiper.slides ? this.swiper.slides.length : totalSlides;
    } else {
      // Fallback: détecter le slide actif par sa classe
      const activeSlide = this.querySelector('.swiper-slide-active');
      if (activeSlide) {
        const slides = Array.from(this.querySelectorAll('.swiper-slide'));
        currentSlide = slides.indexOf(activeSlide) + 1;
      }
    }
    
    this.counter.textContent = `${currentSlide} / ${totalSlides}`;
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);